"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

function _default(type, currentTextNode, matched, change) {
  return change.removeNodeByKey(currentTextNode.key).insertBlock({
    type: type,
    isVoid: true
  }).collapseToStartOfNextBlock();
}